define('modules/gallery',['require','exports','module','app','syze','swiper','modules/media/pusher'],function(require, exports, module) {"use strict";

	var app = require("app");
	var Syze = require("syze");
	var Swiper = require("swiper");
	var Media = require("modules/media/pusher");

	var Gallery = Backbone.View.extend({
		
		name : 'gal',

		events : {
			//"click label": "addFilter",
			//"click input:checkbox": "addFilter"
		},
		makeActive : function() {

			//this.$el.addClass("active");
		},

		render : function() {

			Media.loader_S_H(false);

			//////console.log ('GAL render');

			this.Stage = new Swiper(this.elements.master, this.config);

		},

		elements : {
			master : document.getElementById('s_container'),
			wrapper : document.getElementById('s_wrapper')

		},

		config : {
			//pagination : '.pagination',
			autoResize : false,
			//paginationClickable : true,
			updateOnImagesReady : false,
			noSwiping : true,
			//mousewheelControl : true,
			mousewheelControlForceToAxis : true,
			mode : 'vertical',

			onFirstInit : function(swiper) {

				//console.log ('first init' , swiper.activeIndex);

				Syze.debounceRate(500).callback(function(currentSize) {
					//////console.log (currentSize);
					swiper.resizeFix();
				});

				//	Media

			},

			onInit : function(swiper) {

				//////console.log ('init');

				/*Media.set_navigator(swiper.activeIndex);*/
				return Media.get_media_by_id(swiper.activeSlide());

			},
			onSwiperCreated : function(swiper) {

				
				Media.set_navigator(swiper.activeIndex);
				
				var fx=Media.hideArrow;
				if(swiper.activeIndex === 0){
					fx=Media.showArrow;
					
				}
				
				fx();

				//swiper.activeIndex === 0 ? Media.showArrow() : Media.hideArrow();

				return Media.get_media_by_id(swiper.activeSlide());

			},



			onSlideChangeEnd : function(swiper, dir) {
				//////console.log ("---",swiper.activeIndex);
				
				var fx= Media.hideArrow;
				
				if (swiper.activeIndex === 0 ){
					fx=Media.showArrow;
					} 
					
					fx();

				////////console.log ('START', swiper.activeIndex , dir,swiper.activeSlide()  ,  'OLD INDEX ->' , (swiper.previousIndex) );
				Media.set_navigator(swiper.activeIndex);
				
					var tipo=modules_cfg[swiper.getSlide(swiper.activeIndex ).getAttribute('id')].contents.type;
				
				if( tipo==='animate'  ){

				return Media.get_media_by_id(swiper.activeSlide());
				
				}
				

			},

			onSlideChangeStart : function(swiper) {

			// console.log ('START', swiper.activeIndex   , modules_cfg[swiper.getSlide(swiper.activeIndex ).getAttribute('id')].contents.type     ,'OLD INDEX ->' , (swiper.previousIndex));

				Media.unload_media(swiper.getSlide(swiper.previousIndex));

				app.router.navigate("s/" + swiper.activeSlide().id);
				
				
				var tipo=modules_cfg[swiper.getSlide(swiper.activeIndex ).getAttribute('id')].contents.type;
				
				
				if( tipo!='animate'  ){

				return Media.get_media_by_id(swiper.activeSlide());
				
				}

			},

			onSlideTouch : function(swiper, dir) {

				//console.log ('Start', swiper.activeIndex , dir ,swiper.activeSlide());

			}
		},

		moveTo : function(name) {

			////////console.log ("--->", name , this.NametoInt(name) - 1)

			this.Stage.swipeTo(this.NametoInt(name) - 1);

		},

		NametoInt : function(id) {

			var node = document.getElementById(id);

			var i = 1;
			if (node !== null) {
				var prop = document.body.previousElementSibling ? 'previousElementSibling' : 'previousSibling';

				while (( node = node[prop]) !== null) {
					if (node.nodeType === 1) {
						i++;
					}
				}
			}

			return i;

	

		},

		initialize : function(opt) {

			if (!_.isUndefined(opt) && !_.isNull(opt.hash)) {

				var n = (this.NametoInt(opt.hash) - 1);

				this.config.initialSlide = n;

			
			}

			this.elements.master.className = "swiper-container";
			this.elements.wrapper.className = "swiper-wrapper";

			//	//////console.log ("WHERE",  _.filter( modules_cfg , function(elm){  return  elm.contents.type=='animate'   }    )      );

			if (app.current_device != 'mobile') {

				/*var edgeElm = _.filter(modules_cfg, function(elm) {
					return elm.contents.type == 'animate';
				});

				_.map(edgeElm, function(elm, i, l) {

					if (elm.contents.type === 'animate') {

					Media.get_media_by_id(document.getElementById(elm.contents['module-id']), {
							counter : l.length
						});

					}

				});*/

			} else {

			}

			//if(edgeElm.length===0){
			//////console.log ("NO EDGE ");
			this.render();
			//	}

			//this.render();

			this.elements = {};
		}
	});

	module.exports = Gallery;
});

